interface MerchantAssociationLike {
  merchant_id: string;
  merchants?: {
    shopify_store_domain?: string | null;
  } | null;
}

export function normalizeShopDomain(value?: string | null): string {
  return (value || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "");
}

export function getPreferredMerchantAssociation<T extends MerchantAssociationLike>(
  merchantUsers: T[],
  options?: {
    preferredShop?: string | null;
    storedMerchantId?: string | null;
  },
): T | null {
  if (!merchantUsers.length) {
    return null;
  }

  const normalizedPreferredShop = normalizeShopDomain(options?.preferredShop);
  if (normalizedPreferredShop) {
    const shopMatch = merchantUsers.find((merchantUser) => {
      const merchantShopDomain = normalizeShopDomain(
        merchantUser.merchants?.shopify_store_domain,
      );
      return merchantShopDomain === normalizedPreferredShop;
    });

    if (shopMatch) {
      return shopMatch;
    }
  }

  if (options?.storedMerchantId) {
    const storedMatch = merchantUsers.find(
      (merchantUser) => merchantUser.merchant_id === options.storedMerchantId,
    );

    if (storedMatch) {
      return storedMatch;
    }
  }

  return merchantUsers[0];
}
